export default __webpack_public_path__ + "static/media/visualizer.d4cd89ee.png";